import React from "react"
import { AppFunctionComponent } from "../../../types"
import logo from "../../../images/layout/logo.svg"
import logoWhite from "../../../images/layout/logo-white.svg"
import MobileMenu from "../../components/mobile-menu/mobile-menu.component"
import NavigationList from "../../components/navigation-list/navigation-list.component"
import Submenu from "../../components/submenu/submenu.component"
import Controls from "../../../components/common/controls-area/controls-area.component"
import {
  HamburgerControl,
  HeaderContainer,
  HeaderSection,
  HeaderSectionWraper,
  HeaderWrapper,
  KickstarterHeaderSection,
  KickstarterHeaderWrapper,
  Logo,
  LogoLink,
} from "./header.styled"
import { SubmenuItem } from "../../types/header.interface"
import { Path } from "../../constants/routes"
import {
  KICKSTARTER_PAGE_PATH,
  WORK_FROM_HOME_PAGE_PATH,
} from "../../../constants/kickstarter"
import styled from "styled-components"
import useTranslationHook from "../../../hooks/use-translation.hook"
import { useMouseHook } from "../../../hooks/use-mouse.hook"

interface Props {
  siteTitle: string
  pathname: string
  navItems: SubmenuItem[]
  mobileMenuOpened: boolean
  openMenu: () => void
  onLogoTap: () => void
  path: Path
  isDark?: boolean
}

const LandingPageLabel = styled.p`
  font-size: 1.3rem;
  font-weight: 500;
  text-transform: lowercase;
  margin-left: 2rem;
  margin-top: 0.34rem;
`

const HeaderBase: AppFunctionComponent<Props> = ({
  siteTitle = "",
  pathname,
  navItems,
  mobileMenuOpened,
  openMenu,
  onLogoTap,
  path,
  isDark,
}) => {
  const { translate } = useTranslationHook()
  const { handleMouseEnter, handleMouseLeave } = useMouseHook()
  const landing =
    pathname.includes(KICKSTARTER_PAGE_PATH) ||
    pathname.includes(WORK_FROM_HOME_PAGE_PATH)
  return landing ? (
    <>
      <KickstarterHeaderWrapper>
        <HeaderSectionWraper>
          <KickstarterHeaderSection>
            <LogoLink>
              <Logo src={logo} alt={`${siteTitle} homepage`} />
              {pathname.includes(WORK_FROM_HOME_PAGE_PATH) && (
                <>
                  <LandingPageLabel>|</LandingPageLabel>
                  <LandingPageLabel>
                    {translate("for remote workers")}
                  </LandingPageLabel>
                </>
              )}
            </LogoLink>
          </KickstarterHeaderSection>
        </HeaderSectionWraper>
      </KickstarterHeaderWrapper>
    </>
  ) : (
    <>
      <HeaderWrapper isDark={isDark} className="main-header">
        <HeaderSectionWraper>
          <HeaderSection>
            <HeaderContainer
              isDark={isDark}
              onFocus={handleMouseEnter}
              onMouseOut={handleMouseLeave}
              onMouseOver={handleMouseEnter}
              aria-label={"Main pages"}
            >
              <LogoLink to={path} onTouchEnd={onLogoTap}>
                <Logo
                  src={isDark ? logoWhite : logo}
                  alt={`${siteTitle} homepage`}
                />
              </LogoLink>
              <NavigationList
                navigationItems={navItems}
                pathname={pathname}
                isDark={isDark}
              />
              <Controls isDark={isDark}>
                <HamburgerControl
                  active={mobileMenuOpened}
                  onClick={openMenu}
                  isDark={isDark}
                />
              </Controls>
            </HeaderContainer>
            <MobileMenu opened={mobileMenuOpened} navigationItems={navItems} />
          </HeaderSection>
        </HeaderSectionWraper>
      </HeaderWrapper>
      <Submenu navigationItems={navItems} pathname={pathname} />
    </>
  )
}

export default HeaderBase
